export default [
  {
    id: 'facebook/react',
    color: '#A9DD95',
    data: [
      {
        x: '2020-05-31',
        y: 1,
      },
      {
        x: '2020-06-07',
        y: 5,
      },
      {
        x: '2020-06-14',
        y: 5,
      },
      {
        x: '2020-06-21',
        y: 9,
      },
      {
        x: '2020-06-28',
        y: 24,
      },
      {
        x: '2020-07-05',
        y: 40,
      },
      {
        x: '2020-07-12',
        y: 27,
      },
      {
        x: '2020-07-19',
        y: 15,
      },
      {
        x: '2020-07-26',
        y: 30,
      },
      {
        x: '2020-08-02',
        y: 18,
      },
      {
        x: '2020-08-09',
        y: 21,
      },
      {
        x: '2020-08-16',
        y: 25,
      },
      {
        x: '2020-08-23',
        y: 17,
      },
      {
        x: '2020-08-30',
        y: 17,
      },
      {
        x: '2020-09-06',
        y: 14,
      },
      {
        x: '2020-09-13',
        y: 11,
      },
      {
        x: '2020-09-20',
        y: 17,
      },
      {
        x: '2020-09-27',
        y: 11,
      },
      {
        x: '2020-10-04',
        y: 10,
      },
      {
        x: '2020-10-11',
        y: 21,
      },
      {
        x: '2020-10-18',
        y: 14,
      },
      {
        x: '2020-10-25',
        y: 10,
      },
      {
        x: '2020-11-01',
        y: 5,
      },
      {
        x: '2020-11-08',
        y: 32,
      },
      {
        x: '2020-11-15',
        y: 13,
      },
      {
        x: '2020-11-22',
        y: 0,
      },
      {
        x: '2020-11-29',
        y: 16,
      },
      {
        x: '2020-12-06',
        y: 35,
      },
      {
        x: '2020-12-13',
        y: 9,
      },
      {
        x: '2020-12-20',
        y: 3,
      },
      {
        x: '2020-12-27',
        y: 0,
      },
      {
        x: '2021-01-03',
        y: 3,
      },
      {
        x: '2021-01-10',
        y: 11,
      },
      {
        x: '2021-01-17',
        y: 19,
      },
      {
        x: '2021-01-24',
        y: 15,
      },
      {
        x: '2021-01-31',
        y: 26,
      },
      {
        x: '2021-02-07',
        y: 26,
      },
      {
        x: '2021-02-14',
        y: 7,
      },
      {
        x: '2021-02-21',
        y: 14,
      },
      {
        x: '2021-02-28',
        y: 5,
      },
      {
        x: '2021-03-07',
        y: 24,
      },
      {
        x: '2021-03-14',
        y: 21,
      },
      {
        x: '2021-03-21',
        y: 34,
      },
      {
        x: '2021-03-28',
        y: 27,
      },
      {
        x: '2021-04-04',
        y: 27,
      },
      {
        x: '2021-04-11',
        y: 31,
      },
      {
        x: '2021-04-18',
        y: 26,
      },
      {
        x: '2021-04-25',
        y: 23,
      },
      {
        x: '2021-05-02',
        y: 28,
      },
      {
        x: '2021-05-09',
        y: 14,
      },
      {
        x: '2021-05-16',
        y: 20,
      },
      {
        x: '2021-05-23',
        y: 6,
      },
    ],
  },
  {
    id: 'microsoft/TypeScript',
    color: '#E7F06F',
    data: [
      {
        x: '2020-05-31',
        y: 30,
      },
      {
        x: '2020-06-07',
        y: 20,
      },
      {
        x: '2020-06-14',
        y: 42,
      },
      {
        x: '2020-06-21',
        y: 34,
      },
      {
        x: '2020-06-28',
        y: 33,
      },
      {
        x: '2020-07-05',
        y: 53,
      },
      {
        x: '2020-07-12',
        y: 27,
      },
      {
        x: '2020-07-19',
        y: 17,
      },
      {
        x: '2020-07-26',
        y: 21,
      },
      {
        x: '2020-08-02',
        y: 27,
      },
      {
        x: '2020-08-09',
        y: 15,
      },
      {
        x: '2020-08-16',
        y: 38,
      },
      {
        x: '2020-08-23',
        y: 24,
      },
      {
        x: '2020-08-30',
        y: 28,
      },
      {
        x: '2020-09-06',
        y: 43,
      },
      {
        x: '2020-09-13',
        y: 34,
      },
      {
        x: '2020-09-20',
        y: 44,
      },
      {
        x: '2020-09-27',
        y: 33,
      },
      {
        x: '2020-10-04',
        y: 51,
      },
      {
        x: '2020-10-11',
        y: 21,
      },
      {
        x: '2020-10-18',
        y: 29,
      },
      {
        x: '2020-10-25',
        y: 43,
      },
      {
        x: '2020-11-01',
        y: 37,
      },
      {
        x: '2020-11-08',
        y: 24,
      },
      {
        x: '2020-11-15',
        y: 14,
      },
      {
        x: '2020-11-22',
        y: 21,
      },
      {
        x: '2020-11-29',
        y: 35,
      },
      {
        x: '2020-12-06',
        y: 26,
      },
      {
        x: '2020-12-13',
        y: 29,
      },
      {
        x: '2020-12-20',
        y: 10,
      },
      {
        x: '2020-12-27',
        y: 11,
      },
      {
        x: '2021-01-03',
        y: 31,
      },
      {
        x: '2021-01-10',
        y: 26,
      },
      {
        x: '2021-01-17',
        y: 20,
      },
      {
        x: '2021-01-24',
        y: 22,
      },
      {
        x: '2021-01-31',
        y: 27,
      },
      {
        x: '2021-02-07',
        y: 22,
      },
      {
        x: '2021-02-14',
        y: 29,
      },
      {
        x: '2021-02-21',
        y: 27,
      },
      {
        x: '2021-02-28',
        y: 36,
      },
      {
        x: '2021-03-07',
        y: 32,
      },
      {
        x: '2021-03-14',
        y: 15,
      },
      {
        x: '2021-03-21',
        y: 25,
      },
      {
        x: '2021-03-28',
        y: 21,
      },
      {
        x: '2021-04-04',
        y: 38,
      },
      {
        x: '2021-04-11',
        y: 21,
      },
      {
        x: '2021-04-18',
        y: 29,
      },
      {
        x: '2021-04-25',
        y: 24,
      },
      {
        x: '2021-05-02',
        y: 25,
      },
      {
        x: '2021-05-09',
        y: 23,
      },
      {
        x: '2021-05-16',
        y: 26,
      },
      {
        x: '2021-05-23',
        y: 12,
      },
    ],
  },
];
